import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../hooks/useAuth";
import logoBlack from '../../../../assets/images/logo-horizontal-black.png';
import { useNavigate } from "react-router-dom";
import { Menubar } from 'primereact/menubar';
import * as PROFILE from "../../../../constants/profile";
import './Navbar.scss';

const Navbar = () => {  
  const navigate = useNavigate();
  const { hasPermission, user, logout } = useAuth();
  const [menuItems, setMenuItems] = useState([]);
  const [mobileMenuItems, setMobileMenuItems] = useState([]);

  const onLogoClick = () => {
    navigate("home");
  };

  const onLogOut = () => {
    logout();
    navigate("home");
  };

  const onDriverAssignmentMenuPress = () => {    
    navigate("driverAssignment");
  };

  const onDriverReportMenuPresssignment = () => {
    navigate("driverReport");
  };


  const loadMenuItems = () => {
    setMenuItems([
      {
        label: user.name,      
        items: [
          {
            label: 'Cerrar sesión',
            icon: 'pi pi-fw pi-power-off',
            command: onLogOut
          }
        ]
      }
    ]);
  };

  const loadMobileMenuItems = () => {
    let items = [];
    if (hasPermission(PROFILE.PERMISSIONS.ASSIGNMENT_BY_DRIVER)) {
      items.push({
        label: "Asignación",      
        items: [
          {
            label: 'Asignación por Conductor',
            // icon: 'pi pi-fw pi-power-off',
            command: onDriverAssignmentMenuPress
          }
        ]
      });
    }
    if (hasPermission(PROFILE.PERMISSIONS.DRIVER_REPORT)) {
      items.push({
        label: "Reportes",
        items: [
          {
            label: 'Reporte Historial',
            // icon: 'pi pi-fw pi-power-off',
            command: onDriverReportMenuPresssignment
          }
        ]
      });
    }    
    items.push({
      label: user.name,      
      items: [
        {
          label: 'Cerrar sesión',
          icon: 'pi pi-fw pi-power-off',
          command: onLogOut
        }
      ]
    });
    setMobileMenuItems(items);
  };

  const start = (
    <>
      <img
        src={logoBlack}
        height="20"
        className="d-inline-block align-top m-2"
        alt="Ecofy logo"
        onClick={onLogoClick}
      />
    </>
  );

  useEffect(()=>{    
    loadMenuItems();
    loadMobileMenuItems();
  }, []);

  return (
    <>
      <nav className="app-navbar d-block d-sm-none">
        <Menubar className="app-navbar-menu-bar" model={mobileMenuItems} start={start} />      
      </nav>
      <nav className="app-navbar d-none d-sm-block">        
        <Menubar className="app-navbar-menu-bar" model={menuItems} start={start} />
      </nav>
    </>
  )
}

export default Navbar;